import { combineReducers } from 'redux';

import planReducer from './planReducer';
import dataReducer from './dataReducer';
import taskReducer from './taskReducer';
import learnExerciseReducer from './learnExerciseReducer';
import taskTemplateReducer from './taskTemplateReducer';
import planInsertionReducer from './planInsertionReducer';
import tasksFetchingReducer from './tasksFetchingReducer';
import userReducer from './userReducer';
import authReducer from './authReducer';
import practiceExerciseReducer from './practiceExerciseReducer';
import quizReducer from './quizReducer';
import assessmentReducer from './assessmentReducer';
import completedTaskReducer from './completedTaskReducer';
import planAssignmentReducer from './planAssignmentReducer';
import callTypeReducer from './callTypeReducer';
import callSlotReducer from './callSlotReducer';
import therapistReducer from './therapistReducer';
import moderatorReducer from './moderatorReducer';
import multiTemplateReducer from './multiTemplateReducer';
import dayReducer from './dayReducer';
import offerReducer from './offerReducer';
import videoExerciseReducer from './videoExerciseReducer';

export default combineReducers({
  plans: planReducer,
  plan: planInsertionReducer,
  task: dataReducer,
  tasks: tasksFetchingReducer,
  days: dayReducer,
  taskTypes: taskReducer,
  learnExercises: learnExerciseReducer,
  taskTemplate: taskTemplateReducer,
  user: userReducer,
  auth: authReducer,
  practiceExercises: practiceExerciseReducer,
  quizes: quizReducer,
  assessments: assessmentReducer,
  completedTasks: completedTaskReducer,
  planAssignments: planAssignmentReducer,
  callTypes: callTypeReducer,
  callSlots: callSlotReducer,
  therapist: therapistReducer,
  moderator: moderatorReducer,
  multiTemplate: multiTemplateReducer,
  offers: offerReducer,
  videoExercises: videoExerciseReducer,
});
